import { numFormatter } from '../../../../shared/utils/number/formatter';

export function FieldsCountCell({ fieldsCount }: { fieldsCount: number }) {
  return <div data-id='fields-count-cell'>{numFormatter(fieldsCount)}</div>;
}
